import moment from "moment";
import { Install } from "../../../utils/types";

export const isActiveInstall = ({
  installed_at,
  uninstalled_at
}: Partial<Install>) =>
  moment(installed_at).utc().isBefore(moment().utc()) &&
  ((uninstalled_at && moment(uninstalled_at).utc().isAfter(moment().utc())) ||
    !uninstalled_at);
